import { defineStyle } from "@chakra-ui/react";

export const PracticeLayoutStyles = () => {
  return {
    mainContainer: defineStyle({
      // display: "grid",
      // gridTemplateColumns: "repeat(14,1fr)",
      // gap: "24px",
    }),
    subContainer: defineStyle({
      // gridColumn: { base: "1/15", md: "2/14", lg: "3/13" },
      marginTop: ["34px", "40px", "40px", "50px", "58px", "58px"],
      // marginTop: 0,
    }),
    standaloneSubContainer: defineStyle({
      // gridColumn: { base: "1/15", md: "2/14", lg: "3/13" },
      //marginTop: ["34px", "40px", "40px", "50px", "58px", "58px"],
      marginTop: 0,
    }),
    hideScrollbar: defineStyle({
      marginTop: "-40px",
      overflowY: "visible",
      scrollbarWidth: "none",
      msOverflowStyle: "none",
      "&::-webkit-scrollbar": {
        display: "none",
      },
    }),
  };
};
